import {
  AlignItemsProps,
  compose,
  css,
  flexbox,
  grid,
  GridProps as SSGridProps,
  layout,
  LayoutProps,
  space,
  SpaceProps,
} from '@wrisk/styled-system'
import { PropsWithChildren } from 'react'
import styled from 'styled-components'

import { withDefaultProps } from '../../defaultProps'
import { transition, TransitionProps } from '../../transition'
import { collapse, CollapseProps } from '../containers/collapse'
import { containerStyle, ContainerStyleProps } from './containerStyle'

export type GridProps = SSGridProps &
  LayoutProps &
  SpaceProps &
  ContainerStyleProps &
  TransitionProps &
  AlignItemsProps &
  CollapseProps &
  PropsWithChildren

const defaultProps = withDefaultProps<GridProps>({
  variant: 'default',
})

export const Grid = styled.div.attrs<GridProps>(defaultProps)(
  css({
    display: 'grid',
  }),
  containerStyle,
  compose(grid, flexbox, layout, space, transition, collapse),
)
